<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0">
      <div class="flex mb-20">
        <div>
          <h2 class="mb-2 form-label">Tilldelade</h2>
          <select multiple class="w-64 h-64 overflow-auto form-multiselect" v-model="selectedassignedResources">
            <option v-for="r in assignedResources" :key="r" :value="r">
              {{r.name}}
            </option>
          </select>
        </div>

        <div class="flex flex-col mt-32 ml-5 mr-5">
          <button class="w-24 mb-2 btn_blue" @click="onAdd">
            lägg till
          </button>
          <button class="w-24 btn_blue" @click="onRemove">
            ta bort
          </button>
        </div>

        <div>
          <h2 class="mb-2 form-label">Tillgängliga</h2>
          <select multiple class="w-64 h-64 overflow-auto form-multiselect" v-model="selectedunassignedResources">
            <option v-for="r in unassignedResources" :key="r" :value="r">
              {{r.name}}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { IdentityResourcesService } from "@/services/api-service";

export default {
  name: "identityresources",
  data() {
    return {
      resources: [],
      selectedassignedResources: [],
      selectedunassignedResources: []
    };
  },

  computed: {
    ...mapGetters("clientsStore", ["current"]),
    assignedResources() {
      return this.test(this.resources, 1);
    },
    unassignedResources() {
      return this.test(this.resources, 0);
    }
  },

  methods: {
    ...mapActions("clientsStore", ["addResources", "removeResources"]),

    onAdd() {
      this.addResources(this.selectedunassignedResources);
    },
    onRemove() {
      this.removeResources(this.selectedassignedResources);
    },

    test(resource, type) {
      let anotherOne = this.current.allowedScopes;

      return resource.filter(
        array_el =>
          anotherOne.filter(anotherOne_el => anotherOne_el === array_el.name)
            .length === type
      );
    },

    async mounted() {
      const { data } = await IdentityResourcesService.query({
        limit: 100,
        offset: 0
      });
      this.resources = data.identityResources;
    }
  }
};
</script>
